export interface IKeyLabelPair {
  key: string;
  label: string;
}

export type ValidationStatus = 'VALID' | 'INVALID';

export interface MFEAddress {
  readonly street: string;
  readonly city: string;
  readonly zipCode: string;
  readonly state: string;
}
